import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useCheckout() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(null);

  const checkout = async (lookup_key, extra = {}) => {
    if (!user) { navigate("/login", { state: { from: window.location.pathname } }); return; }
    if (!user.seller_type) { navigate("/onboard"); return; }
    setBusy(extra.listing_id ? `${lookup_key}-${extra.listing_id}` : lookup_key);
    try {
      const { data } = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin, ...extra });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setBusy(null);
    }
  };
  return { busy, checkout };
}
